import OurClients from "pages/LandingPages/OurClients";
export default function Ourclients() {
  return <OurClients />;
}
